module.exports = __webpack_public_path__ + "img/TM-qr.785bb62d.png";